import { Component, signal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { TopNav } from "../top-nav/top-nav";
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { SearchInpComponent } from '../search-inp/search-inp.component';


@Component({
  selector: 'app-nav',
  standalone: true,
  templateUrl: './nav.html',
  // UserMenuComponent
  styleUrl: './nav.scss',
  imports: [TranslateModule, SearchInpComponent, CommonModule, TopNav, RouterLink, RouterLinkActive],
})
export class Nav {
  public isAuthenticated$!: Observable<boolean>;
  public isMobile$!: Observable<boolean>;
  showSearch = signal<boolean>(false);
  sections!: Observable<[]>;
  menuCollapsed = new BehaviorSubject(true);
  constructor(public translate: TranslateService, private router: Router, public route: ActivatedRoute,) { }

  ngOnInit(): void {

    // super.ngOnInit();
    // this.isMobile$ = this.windowService.isUpTo(this.maxMobileWidth);
    // this.isAuthenticated$ = this.store.pipe(select(isAuthenticated));
  }

  toggleMenu() {
    this.menuCollapsed.next(!this.menuCollapsed.value);
  }

  onSearch(value: string | null, modelName?: string): void {
    this.showSearch.set(false);

    let searchTerm = value?.trim() || modelName?.trim();
    if (!searchTerm) {
      return;
    }

    this.router.navigate(
      ['/browse-index'],
      {
        queryParams: {
          q: searchTerm
        }
      }
    );
  }

  onTranslatedSearch(key: string) {
    this.showSearch.set(false);
    // this.searchValue = key;
    this.onSearch(null, key);
  }
  changeLanguage() {
    const lang = this.translate.getCurrentLang() === 'en' ? 'ar' : 'en';
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }
}
